import { Component, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../tooltip-info/tooltip-info.component';
import { NgClass } from '@angular/common';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { TimePickerComponent } from '../time-picker/time-picker.component';
import { KeyFilterModule } from 'primeng/keyfilter';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { TooltipInReportComponent } from "../tooltip-in-report/tooltip-in-report.component";

@Component({
    selector: 'field-type-time',
    templateUrl: './field-type-time.component.html',
    standalone: true,
    imports: [NgClass,
    TooltipInfoComponent,
    TooltipLawComponent,
    TooltipModule,
    FormsModule,
    AfTranslateDirective,
    AfTranslatePipe,
    OverlayPanelModule,
    TimePickerComponent,
    KeyFilterModule, TooltipInReportComponent]
})
export class FieldTypeTimeComponent implements OnChanges, AfterViewInit {
  isLanding: boolean = this.customLanding.isLanding();
  constructor(
    private customLanding: CustomLandingFactory,
    private commonUtilsService: CommonUtilsService
  ) { }

  @Input() field: any;
  @Input() preSelectItem: any;
  @Output() itemSelected = new EventEmitter();
  @Output() openRelatedInfo = new EventEmitter();
  @ViewChild(OverlayPanel) overlayPanel: OverlayPanel;
  @ViewChild('containerFieldTime') containerFieldTimeElement: ElementRef;

  fieldTypeTime: any = {
    inputHour: '',//'00'
    inputMinute: ''//'00'
  }

  ngOnChanges() {
    let that = this.fieldTypeTime;
    let field = this.field;

    if (field) {
      that.titleField = field.label;
      if (field.extendedLabel && field.extendedLabel !== '') {
        that.titleField = field.extendedLabel;
      }
      field.id = field.generateId || !field.fieldId?this.commonUtilsService.createId() : field.fieldId;
      if(this.field.inReport !== null && field.inReport !== undefined){
        this.fieldTypeTime.inReport = this.field.inReport.indexOf('|') === -1? [this.field.inReport] : this.field.inReport.split('|')
      }
    }
    this.configureTime(this.preSelectItem);
  }

  ngAfterViewInit(): void {
    this.commonUtilsService.bindScrollOverlayListener(this.overlayPanel);
  }

  configureTime(item: any) {
    let that = this.fieldTypeTime;
    if (item !== undefined && item !== null) {
      let time = item.split(':');
      that.hour = time[0].substr(0, 2);
      that.minute = time[1].substr(0, 2);
      that.inputHour = that.hour;
      that.inputMinute = that.minute;
    }
  }

  changeInField(type: any, e: any){
    this.validateTime(type);
    this.checkValidateTime();
  }

  checkValidateTime(){
    const hourRegex = /^([0-1][0-9]|2[0-3])$/g;
    const minuteRegex = /^([0-5][0-9])$/g;
    if(hourRegex.test(this.fieldTypeTime.inputHour) && minuteRegex.test(this.fieldTypeTime.inputMinute)){
      this.field.error = false;
      this.itemSelected.emit({newValue:this.createTime(this.fieldTypeTime.inputHour, this.fieldTypeTime.inputMinute)})
    }
  }

  createTime(inputHour:any, inputMinute:any) {
    return this.fieldTypeTime.time = (inputHour + ':' + inputMinute + ':' + '00');
  }

  validateTime(type: any){
    let typePicker: any = parseInt(this.fieldTypeTime['input' + type]);
    if(type === 'Hour' && (typePicker > 2 || this.fieldTypeTime['input' + type].length === 2)){
      this.fieldTypeTime.inputHour = typePicker <= 9 ? '0' + typePicker : (typePicker > 23 ? '23' : this.fieldTypeTime.inputHour + '');
      this.fieldTypeTime.validatedTime = true;
      let inputMinute: any = document.getElementById('time-picker-minute-' + this.field.id);
      inputMinute.focus();
      inputMinute.select();
    }else if(type === 'Minute' && (typePicker > 5 || this.fieldTypeTime['input' + type].length === 2)){
      this.fieldTypeTime.inputMinute = typePicker <= 9 ? '0' + typePicker : (typePicker > 59 ? '59' : this.fieldTypeTime.inputMinute + '');
      this.fieldTypeTime.validatedTime = true;
      let inputMinute: any = document.getElementById('time-picker-minute-' + this.field.id);
      inputMinute.blur();
    }
  }

  blurInputTime(type: any = 'hours'){
    if(!this.fieldTypeTime.validatedTime){
      let typePicker : any = parseInt(this.fieldTypeTime['input' + type]);
      if(!typePicker){
        this.fieldTypeTime['input' + type] = '';//'00'
      }
    }else{
      delete this.fieldTypeTime.validatedTime;
    }
  }

  resetInput(){
    this.fieldTypeTime.inputText = '';
    this.fieldTypeTime.inputHour ='';//'00'
    this.fieldTypeTime.inputMinute = '';//'00'
  }

  changeInTimePicker(event: any){
    this.fieldTypeTime.inputHour = event.hours + '';
    this.fieldTypeTime.inputMinute = event.minutes + '';
    this.checkValidateTime();
  }

  showTooltipInfo(e:any){
      this.fieldTypeTime.showInfo = !this.fieldTypeTime.showInfo;
  }

  openModalRelatedInfo(fieldRelatedInfo:any){
      this.openRelatedInfo.emit({relatedInfo:fieldRelatedInfo});
  }

  toggleFilter(e: any){
    this.commonUtilsService.toggleFilterOverlay(e, this.overlayPanel, 'overlay', this.containerFieldTimeElement.nativeElement);
  }
}
